import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  scheduleTitle: {
    id: 'course-authoring.schedule.schedule-section.title',
    defaultMessage: 'Course schedule',
  },
  scheduleDescription: {
    id: 'course-authoring.schedule.schedule-section.description',
    defaultMessage: 'Dates that control when your course can be viewed',
  },
  scheduleCourseStartDateLabel: {
    id: 'course-authoring.schedule.schedule-section.course-start.date.label',
    defaultMessage: 'Course start date',
  },
  scheduleCourseStartDateHelpText: {
    id: 'course-authoring.schedule.schedule-section.course-start.date.help-text',
    defaultMessage: 'First day the course begins',
  },
  scheduleCourseStartTimeLabel: {
    id: 'course-authoring.schedule.schedule-section.course-start.time.label',
    defaultMessage: 'Course start time',
  },
  scheduleCourseEndDateLabel: {
    id: 'course-authoring.schedule.schedule-section.course-end.date.label',
    defaultMessage: 'Course end date',
  },
  scheduleCourseEndDateHelpText: {
    id: 'course-authoring.schedule.schedule-section.course-end.date.help-text',
    defaultMessage: 'Last day your course is active',
  },
  scheduleCourseEndTimeLabel: {
    id: 'course-authoring.schedule.schedule-section.course-end.time.label',
    defaultMessage: 'Course end time',
  },
  scheduleEnrollmentStartDateLabel: {
    id: 'course-authoring.schedule.schedule-section.enrollment-start.date.label',
    defaultMessage: 'Enrollment start date',
  },
  scheduleEnrollmentStartDateHelpText: {
    id: 'course-authoring.schedule.schedule-section.enrollment-start.help-text',
    defaultMessage: 'First day students can enroll',
  },
  scheduleEnrollmentStartTimeLabel: {
    id: 'course-authoring.schedule.schedule-section.enrollment-start.time.label',
    defaultMessage: 'Enrollment start time',
  },
  scheduleEnrollmentEndDateLabel: {
    id: 'course-authoring.schedule.schedule-section.enrollment-end.date.label',
    defaultMessage: 'Enrollment end date',
  },
  scheduleEnrollmentEndDateHelpText: {
    id: 'course-authoring.schedule.schedule-section.enrollment-end.date.help-text',
    defaultMessage: 'Last day students can enroll.',
  },
  scheduleEnrollmentEndDateRestrictedHelpText: {
    id: 'course-authoring.schedule.schedule-section.enrollment-end.date.restricted.help-text',
    defaultMessage: 'Contact your {platformName} partner manager to update these settings.',
  },
  scheduleEnrollmentEndTimeLabel: {
    id: 'course-authoring.schedule.schedule-section.enrollment-end.time.label',
    defaultMessage: 'Enrollment end time',
  },
  scheduleUpgradeDeadlineDateLabel: {
    id: 'course-authoring.schedule.schedule-section.upgrade-deadline.date.label',
    defaultMessage: 'Upgrade deadline date',
  },
  scheduleUpgradeDeadlineDateHelpText: {
    id: 'course-authoring.schedule.schedule-section.upgrade-deadline.date.help-text',
    defaultMessage: 'Last day students can upgrade to a verified enrollment. Contact your {platformName} partner manager to update these settings.',
  },
  scheduleUpgradeDeadlineTimeLabel: {
    id: 'course-authoring.schedule.schedule-section.upgrade-deadline.time.label',
    defaultMessage: 'Upgrade deadline time',
  },
});

export default messages;
